'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import CommonContainer from '@components/CommonContainer';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxBlock from '@components/ParallaxBlock';
import CustomImage from '@components/CustomImage';
import cn from './style.module.scss';
export default function TheResidencesDesigning(
  props: MarketingPageComponentProps
) {
  const theResidencesLibraryBlockElement =
    props?.locale?.section?.residencesTowerDesignDisplay ?? [];
  return (
    <Stack
      component="section"
      className={cn.theResidencesDesigning}
      sx={{
        backgroundImage: `url(${props.images.westminster_tower_light_background?.src})`,
      }}
    >
      <Box className={cn.residencesDesigningInner}>
        <Box className={cn.residencesDesigningBlock}>
          <Box component="picture" className={cn.residencesDesigningStory}>
            <ParallaxBlock
              className={cn.residencesDesigningElement}
              animationType="zoomIn"
              animationDuration={500}
            >
              <CustomImage
                src={
                  props.images.westminster_tower_residences_mustard?.src || ''
                }
                alt="Yas Living Location Map"
                width={768}
                height={768}
              />
            </ParallaxBlock>
          </Box>
          <Box component="article" className={cn.residencesDesigningContent}>
            <ParallaxText
              variant="h2"
              animationType="slideInBottom"
              animationDuration={500}
            >
              {ReactHtmlParser(
                props.locale.section.residencesTowerDesignHeading
              )}
            </ParallaxText>
            <ParallaxText
              variant="p"
              animationType="slideInBottom"
              animationDuration={500}
            >
              {ReactHtmlParser(
                props.locale.section.residencesTowerDesignContent
              )}
            </ParallaxText>
          </Box>
        </Box>
      </Box>
      <Box className={cn.residencesLibraryWrapper}>
        <Box className={cn.residencesLibraryBlock}>
          {theResidencesLibraryBlockElement.map((item: any, index: number) => (
            <Box
              key={item?.url || index}
              className={cn.residencesLibraryElement}
            >
              <CustomImage
                src={item?.url ?? ''}
                alt={item?.alt ?? `residences-library-slide-${index}`}
                width={1200}
                height={800}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Stack>
  );
}
